import type { Trophy } from '../types';

export type { Trophy } from '../types';

export const trophies: Trophy[] = [
  // Săptămâna 1: Setup + Structură + Progres (5 trofee)
  {
    id: 'primul-pas',
    nume: 'Primul Pas',
    descriere: 'Ai instalat toate uneltele necesare și ai pornit pe drumul dezvoltării web!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="28" fill="#FFD700"/><path d="M20 35l8 8 16-20" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    aiPrompt: 'A golden trophy with a checkmark, representing first steps in coding, cartoon style'
  },
  {
    id: 'arhitect-junior',
    nume: 'Arhitect Junior',
    descriere: 'Ai creat prima structură de foldere pentru proiectul tău!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="20" width="40" height="32" rx="2" fill="#4A90D9"/><path d="M12 26h40" stroke="#2C5282" stroke-width="2"/><rect x="18" y="32" width="12" height="8" fill="#FFF"/><rect x="34" y="32" width="12" height="8" fill="#FFF"/></svg>`,
    aiPrompt: 'A blueprint trophy with folder structure icons, architectural theme, cartoon style'
  },
  {
    id: 'component-master',
    nume: 'Maestru Componente',
    descriere: 'Ai învățat să creezi componente React reutilizabile!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="24" fill="#61DAFB"/><circle cx="32" cy="32" r="6" fill="#333"/><ellipse cx="32" cy="32" rx="24" ry="10" stroke="#333" stroke-width="2" fill="none"/><ellipse cx="32" cy="32" rx="24" ry="10" stroke="#333" stroke-width="2" fill="none" transform="rotate(60 32 32)"/><ellipse cx="32" cy="32" rx="24" ry="10" stroke="#333" stroke-width="2" fill="none" transform="rotate(120 32 32)"/></svg>`,
    aiPrompt: 'A React atom logo trophy, glowing blue, modern tech style'
  },
  {
    id: 'navigator',
    nume: 'Navigator',
    descriere: 'Ai implementat navigarea între pagini cu React Router!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="26" fill="#E8E8E8"/><path d="M32 10v44M10 32h44" stroke="#333" stroke-width="2"/><polygon points="32,8 38,22 26,22" fill="#D32F2F"/><circle cx="32" cy="32" r="4" fill="#333"/></svg>`,
    aiPrompt: 'A compass trophy pointing forward, navigation theme, adventure style'
  },
  {
    id: 'salvator-progres',
    nume: 'Salvator de Progres',
    descriere: 'Ai învățat să salvezi datele în localStorage!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="12" width="40" height="40" rx="4" fill="#4CAF50"/><rect x="20" y="12" width="24" height="16" fill="#81C784"/><rect x="24" y="36" width="16" height="12" fill="#FFF"/></svg>`,
    aiPrompt: 'A floppy disk trophy with save icon, retro tech style, golden glow'
  },

  // Săptămâna 2: CSS + Grid + Accesibilitate (5 trofee)
  {
    id: 'stilist',
    nume: 'Stilist',
    descriere: 'Ai aplicat primele stiluri CSS și ai făcut pagina să arate frumos!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="26" fill="#9C27B0"/><path d="M20 24c0-4 8-8 12-8s12 4 12 8-4 8-12 16-12-12-12-16z" fill="#E1BEE7"/><path d="M32 48v-8" stroke="#FFF" stroke-width="3"/></svg>`,
    aiPrompt: 'A paint palette trophy with CSS colors, artistic design style'
  },
  {
    id: 'grid-guru',
    nume: 'Grid Guru',
    descriere: 'Ai stăpânit CSS Grid și ai creat layout-uri complexe!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="44" height="44" fill="#2196F3"/><path d="M10 25h44M10 39h44M25 10v44M39 10v44" stroke="#FFF" stroke-width="2"/></svg>`,
    aiPrompt: 'A grid layout trophy, geometric patterns, modern design'
  },
  {
    id: 'flex-master',
    nume: 'Flex Master',
    descriere: 'Ai învățat Flexbox și aliniezi elemente ca un profesionist!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="22" width="44" height="20" rx="4" fill="#FF9800"/><rect x="14" y="26" width="10" height="12" fill="#FFF"/><rect x="27" y="26" width="10" height="12" fill="#FFF"/><rect x="40" y="26" width="10" height="12" fill="#FFF"/></svg>`,
    aiPrompt: 'A flexible ribbon trophy, stretching elements, playful style'
  },
  {
    id: 'accesibilitate-erou',
    nume: 'Erou al Accesibilității',
    descriere: 'Ai făcut site-ul accesibil pentru toți utilizatorii!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="26" fill="#00BCD4"/><circle cx="32" cy="20" r="6" fill="#FFF"/><path d="M32 28v12M24 32h16M26 48l6-8 6 8" stroke="#FFF" stroke-width="3" stroke-linecap="round"/></svg>`,
    aiPrompt: 'An accessibility trophy with universal access symbol, inclusive design, friendly style'
  },
  {
    id: 'responsive-ninja',
    nume: 'Ninja Responsive',
    descriere: 'Site-ul tău arată perfect pe orice dispozitiv!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="14" width="24" height="36" rx="2" fill="#607D8B"/><rect x="10" y="18" width="20" height="28" fill="#90A4AE"/><rect x="36" y="20" width="20" height="14" rx="1" fill="#607D8B"/><rect x="38" y="22" width="16" height="10" fill="#90A4AE"/></svg>`,
    aiPrompt: 'A ninja trophy with multiple device screens, responsive design theme'
  },

  // Săptămâna 3: Logică + Filtre + Teste (5 trofee)
  {
    id: 'logician',
    nume: 'Logician',
    descriere: 'Ai implementat logică complexă cu condiții și bucle!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="26" fill="#673AB7"/><path d="M24 20v8l8 4-8 4v8M40 20v8l-8 4 8 4v8" stroke="#FFF" stroke-width="2"/></svg>`,
    aiPrompt: 'A brain trophy with logic gates, thinking theme, intellectual style'
  },
  {
    id: 'filtru-expert',
    nume: 'Expert Filtre',
    descriere: 'Ai creat filtre și căutare pentru datele tale!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="28" r="14" stroke="#FF5722" stroke-width="4" fill="#FFCCBC"/><path d="M38 38l14 14" stroke="#FF5722" stroke-width="4" stroke-linecap="round"/></svg>`,
    aiPrompt: 'A magnifying glass trophy with filter funnel, search theme, detective style'
  },
  {
    id: 'tester',
    nume: 'Tester',
    descriere: 'Ai scris primul test și ai verificat că codul funcționează!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="14" y="10" width="36" height="44" rx="2" fill="#4CAF50"/><path d="M22 24l6 6 14-14" stroke="#FFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 42h20M22 50h12" stroke="#FFF" stroke-width="2"/></svg>`,
    aiPrompt: 'A clipboard trophy with checkmarks, testing theme, quality assurance style'
  },
  {
    id: 'bug-hunter',
    nume: 'Vânător de Bug-uri',
    descriere: 'Ai găsit și reparat un bug dificil!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="36" r="16" fill="#F44336"/><circle cx="26" cy="32" r="3" fill="#FFF"/><circle cx="38" cy="32" r="3" fill="#FFF"/><path d="M26 42c3 2 9 2 12 0" stroke="#FFF" stroke-width="2"/><path d="M18 24l6 8M46 24l-6 8M16 36h6M42 36h6M20 48l4-6M44 48l-4-6" stroke="#333" stroke-width="2"/></svg>`,
    aiPrompt: 'A bug with crosshairs trophy, debugging theme, hunter style'
  },
  {
    id: 'state-manager',
    nume: 'Manager de State',
    descriere: 'Ai învățat să gestionezi state-ul aplicației!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="12" width="40" height="40" rx="20" fill="#3F51B5"/><circle cx="24" cy="32" r="4" fill="#FFF"/><circle cx="40" cy="32" r="4" fill="#FFF"/><path d="M28 32h8" stroke="#FFF" stroke-width="2" marker-end="url(#arrow)"/></svg>`,
    aiPrompt: 'A state machine trophy with connected nodes, flow diagram style'
  },

  // Săptămâna 4: Mini-joc (5 trofee)
  {
    id: 'game-dev',
    nume: 'Game Developer',
    descriere: 'Ai creat primul tău joc cu Canvas!',
    categorie: 'game',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="18" width="48" height="28" rx="4" fill="#9C27B0"/><circle cx="20" cy="32" r="6" fill="#E1BEE7"/><circle cx="44" cy="28" r="3" fill="#4CAF50"/><circle cx="44" cy="36" r="3" fill="#F44336"/></svg>`,
    aiPrompt: 'A game controller trophy, gaming theme, pixel art style'
  },
  {
    id: 'coin-collector',
    nume: 'Colector de Monede',
    descriere: 'Ai colectat primele 10 monede în joc!',
    categorie: 'game',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="24" fill="#FFD700"/><circle cx="32" cy="32" r="18" fill="#FFC107"/><text x="32" y="40" text-anchor="middle" font-size="20" fill="#B8860B">$</text></svg>`,
    aiPrompt: 'A golden coin trophy, shiny metal, treasure theme'
  },
  {
    id: 'speed-runner',
    nume: 'Speed Runner',
    descriere: 'Ai terminat nivelul în mai puțin de 20 de secunde!',
    categorie: 'game',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="26" fill="#2196F3"/><path d="M32 16v18l10 6" stroke="#FFF" stroke-width="3" stroke-linecap="round"/><circle cx="32" cy="32" r="3" fill="#FFF"/></svg>`,
    aiPrompt: 'A stopwatch trophy with speed lines, racing theme, dynamic style'
  },
  {
    id: 'arcade-champ',
    nume: 'Arcade Champ',
    descriere: 'Ai obținut scorul maxim în mini-joc!',
    categorie: 'game',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><polygon points="32,4 38,24 60,24 42,38 48,58 32,46 16,58 22,38 4,24 26,24" fill="#FFD700"/><circle cx="32" cy="32" r="8" fill="#FFC107"/></svg>`,
    aiPrompt: 'A golden star trophy with crown, champion theme, arcade style'
  },
  {
    id: 'no-damage',
    nume: 'Invincibil',
    descriere: 'Ai terminat un nivel fără să pierzi nicio viață!',
    categorie: 'game',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 56s-20-12-20-28c0-8 6-14 14-14 4 0 6 2 6 2s2-2 6-2c8 0 14 6 14 14 0 16-20 28-20 28z" fill="#E91E63"/><path d="M26 24l4 4 8-8" stroke="#FFF" stroke-width="3" stroke-linecap="round"/></svg>`,
    aiPrompt: 'A shield trophy with heart, invincibility theme, protective style'
  },

  // Săptămâna 5: AI Generator + Securizare (3 trofee + 2 AI)
  {
    id: 'ai-explorer',
    nume: 'Explorator AI',
    descriere: 'Ai generat primul trofeu cu ajutorul AI!',
    categorie: 'ai',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="26" fill="#00BCD4"/><circle cx="24" cy="28" r="4" fill="#FFF"/><circle cx="40" cy="28" r="4" fill="#FFF"/><path d="M22 40c5 4 15 4 20 0" stroke="#FFF" stroke-width="2"/><circle cx="24" cy="28" r="2" fill="#333"/><circle cx="40" cy="28" r="2" fill="#333"/></svg>`,
    aiPrompt: 'A robot face trophy, friendly AI theme, futuristic style'
  },
  {
    id: 'prompt-master',
    nume: 'Maestru Prompt',
    descriere: 'Ai creat un prompt perfect și ai obținut rezultatul dorit!',
    categorie: 'ai',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="14" width="44" height="36" rx="4" fill="#607D8B"/><path d="M18 28l8 4-8 4" stroke="#4CAF50" stroke-width="2" stroke-linecap="round"/><path d="M30 36h16" stroke="#FFF" stroke-width="2"/></svg>`,
    aiPrompt: 'A terminal trophy with glowing prompt, command line theme, hacker style'
  },
  {
    id: 'securitate-expert',
    nume: 'Expert Securitate',
    descriere: 'Ai implementat măsuri de securitate pentru aplicație!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8l20 8v16c0 14-20 24-20 24S12 46 12 32V16l20-8z" fill="#4CAF50"/><path d="M26 32l6 6 10-12" stroke="#FFF" stroke-width="3" stroke-linecap="round"/></svg>`,
    aiPrompt: 'A shield trophy with lock icon, security theme, protective style'
  },

  // Săptămâna 6: Export/Import + Deploy + Demo (2 trofee + finale)
  {
    id: 'data-guardian',
    nume: 'Gardian al Datelor',
    descriere: 'Ai implementat export și import pentru progres!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16" y="12" width="32" height="40" rx="2" fill="#795548"/><path d="M24 24h16M24 32h16M24 40h10" stroke="#FFF" stroke-width="2"/><path d="M40 20l8-8M48 12v8h-8" stroke="#4CAF50" stroke-width="2"/></svg>`,
    aiPrompt: 'A data folder trophy with arrows, backup theme, guardian style'
  },
  {
    id: 'deployer',
    nume: 'Deployer',
    descriere: 'Ai publicat aplicația pe internet pentru toată lumea!',
    categorie: 'web',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="24" fill="#2196F3"/><ellipse cx="32" cy="32" rx="24" ry="10" stroke="#FFF" stroke-width="2" fill="none"/><ellipse cx="32" cy="32" rx="10" ry="24" stroke="#FFF" stroke-width="2" fill="none"/><path d="M32 8v48" stroke="#FFF" stroke-width="2"/></svg>`,
    aiPrompt: 'A globe trophy with rocket, deployment theme, launch style'
  },
  {
    id: 'absolvent',
    nume: 'Absolvent',
    descriere: 'Ai completat toate cele 30 de zile! Ești un adevărat dezvoltator!',
    categorie: 'bonus',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8l28 14-28 14L4 22l28-14z" fill="#1A237E"/><path d="M12 26v18l20 12 20-12V26" fill="#3F51B5"/><rect x="30" y="36" width="4" height="20" fill="#FFD700"/><circle cx="32" cy="56" r="4" fill="#FFD700"/></svg>`,
    aiPrompt: 'A graduation cap trophy with golden tassel, achievement theme, celebration style'
  },

  // Trofee bonus
  {
    id: 'colectionar',
    nume: 'Colecționar',
    descriere: 'Ai deblocat 10 trofee diferite!',
    categorie: 'bonus',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="16" width="48" height="36" rx="4" fill="#FF9800"/><rect x="14" y="22" width="12" height="12" fill="#FFF"/><rect x="30" y="22" width="12" height="12" fill="#FFF"/><rect x="14" y="36" width="12" height="12" fill="#FFF"/><rect x="30" y="36" width="12" height="12" fill="#FFF"/></svg>`,
    aiPrompt: 'A trophy case with multiple trophies, collector theme, showcase style'
  },
  {
    id: 'early-bird',
    nume: 'Pasăre Matinală',
    descriere: 'Ai lucrat la proiect dimineața devreme!',
    categorie: 'bonus',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="40" r="20" fill="#FFE082"/><path d="M12 40h-4M52 40h4M32 16v-4M18 26l-3-3M46 26l3-3" stroke="#FFB300" stroke-width="3" stroke-linecap="round"/><circle cx="32" cy="40" r="12" fill="#FFF59D"/></svg>`,
    aiPrompt: 'A sunrise trophy with bird, early morning theme, golden light'
  },
  {
    id: 'perseverent',
    nume: 'Perseverent',
    descriere: 'Ai lucrat 5 zile la rând fără pauză!',
    categorie: 'bonus',
    icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8c-12 0-22 10-22 22 0 8 4 14 10 18l2 12h20l2-12c6-4 10-10 10-18 0-12-10-22-22-22z" fill="#FFC107"/><path d="M26 60h12" stroke="#FF9800" stroke-width="2"/><path d="M28 48h8" stroke="#FF9800" stroke-width="2"/></svg>`,
    aiPrompt: 'A lightbulb trophy with flame, persistence theme, determination style'
  }
];

export const getTrophyById = (id: string): Trophy | undefined => {
  return trophies.find(t => t.id === id);
};

export const getTrophiesByCategory = (category: Trophy['categorie']): Trophy[] => {
  return trophies.filter(t => t.categorie === category);
};
